import { ArrowUpRight, MessageCircle } from "lucide-react";
import { buildWhatsAppLink } from "@/data/lakaData";

const FinalCTA = () => {
  const goTo = (id) =>
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  const wa = buildWhatsAppLink(
    "Hola LAKA, quiero empezar con una valoración personalizada.",
  );

  return (
    <section
      data-testid="final-cta-section"
      className="py-24 md:py-32 relative overflow-hidden"
      style={{ background: "#FBF6F2" }}
    >
      <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
        <span className="laka-eyebrow">Empieza tu ritual</span>
        <h2 className="mt-5 font-serif-laka text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-light leading-[1.02] text-[#1A1A1A]">
          Empieza con una <br />
          <span className="italic text-[#D6B36A]">valoración personalizada</span>
        </h2>
        <p className="mt-6 text-[#1A1A1A]/70 max-w-xl mx-auto leading-relaxed font-light">
          Te ayudamos a elegir el tratamiento más adecuado según tu piel, tu
          cuerpo y tus objetivos.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
          <button
            data-testid="finalcta-book-btn"
            onClick={() => goTo("contacto")}
            className="laka-btn-primary"
          >
            Pedir cita
            <ArrowUpRight className="w-4 h-4" strokeWidth={1.5} />
          </button>
          <a
            data-testid="finalcta-whatsapp-btn"
            href={wa}
            target="_blank"
            rel="noreferrer"
            className="laka-btn-ghost"
          >
            <MessageCircle className="w-4 h-4" strokeWidth={1.5} />
            WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
